import { MapIcon } from "@heroicons/react/24/outline";
import { router } from "@inertiajs/react";
import { useState } from "react";
import type { JourneyRow } from "@/types";

type Props = {
  domainId: string;
  hostname: string;
  rows: JourneyRow[];
};

export default function JourneysMappingComplete({ domainId, hostname, rows }: Props) {
  const [acknowledging, setAcknowledging] = useState(false);
  const jobLabel = rows.length === 1 ? "job" : "jobs";

  const acknowledge = () => {
    if (acknowledging) {
      return;
    }

    setAcknowledging(true);
    router.post(
      `/domains/${domainId}/journey_mapping_acknowledgement`,
      {},
      {
        preserveScroll: true,
        onFinish: () => setAcknowledging(false),
      },
    );
  };

  return (
    <div className="mt-6 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-black/5">
      <div className="flex items-start gap-4 bg-linear-to-br from-primary/15 via-primary/5 to-white px-5 pb-4 pt-5">
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white shadow-sm ring-1 ring-primary/10">
          <MapIcon className="h-7 w-7 text-primary" aria-hidden="true" />
        </div>
        <div className="min-w-0 pt-0.5">
          <p className="text-xs font-medium uppercase tracking-wider text-primary">Mapping complete</p>
          <h2 className="mt-1 text-xl font-semibold tracking-tight text-gray-900">
            We signed in and mapped your product
          </h2>
        </div>
      </div>
      <div className="space-y-4 px-5 py-5">
        <p className="text-sm leading-relaxed text-gray-600">
          We named {rows.length} {jobLabel} on {hostname}. Mapping doesn’t find issues — Audit a journey when you’re
          ready. Each Audit uses one page audit from your plan.
        </p>
        <div className="rounded-lg border border-gray-200 bg-gray-50/80 px-4 py-3">
          <h3 className="text-sm font-semibold text-gray-900">What we mapped</h3>
          <ul className="mt-2 space-y-1.5">
            {rows.map((row) => (
              <li key={row.id} className="flex items-center gap-2 text-sm text-gray-700">
                <span className="text-primary" aria-hidden="true">
                  ✓
                </span>
                {row.title}
              </li>
            ))}
          </ul>
        </div>
        <button
          type="button"
          className="btn btn-primary w-full justify-center"
          disabled={acknowledging}
          onClick={acknowledge}
        >
          {acknowledging ? "Continuing…" : "Continue to journeys"}
        </button>
      </div>
    </div>
  );
}
